export default (function () {
    const normalisations = {

        /**
         * Normalize values to integers.
         *
         * @param {number} value
         *
         * @returns {number}
         */
        integer: function (value) {
            if (!value) {
                return;
            }

            return value.replace(/[^\d]/g, '');
        },

        /**
         * Normalizes the value to the previous value,
         * when the newValue is more then the minValue.
         *
         * @param {number} value
         * @param {number} min
         *
         * @returns {number}
         */
        lessThen: function (value, min) {
            if (!value) {
                return;
            }

            return parseFloat(value) < parseFloat(min) ? min : value;
        },

        /**
         * Normalizes the value to the previous value,
         * when the newValue is more then the maxValue.
         *
         * @param {number} value
         * @param {number} max
         *
         * @returns {number}
         */
        greaterThan: function (value, max) {
            if (!value) {
                return;
            }

            return parseFloat(value) > parseFloat(max) ? max : value;
        },

        /**
         * Normalize values between a min and max value.
         *
         * @param {number} value
         * @param {number} min
         * @param {number} max
         *
         * @returns {number}
         */
        inBetween: function (value, min, max) {
            if (normalisations.isLessThanMinimum(value, min)) {
                return min;
            }

            if (normalisations.isGreaterThanMaximum(value, max)) {
                return max;
            }

            return value;
        },

        /**
         * Check value is less than the min value.
         *
         * @param {number} value
         * @param {number} min
         *
         * @returns {boolean}
         */
        isLessThanMinimum: function (value, min) {
            return parseFloat(value) < parseFloat(min);
        },

        /**
         * Check if value is greater than max value.
         *
         * @param {number} value
         * @param {number} max
         *
         * @returns {boolean}
         */
        isGreaterThanMaximum: function (value, max) {
            return parseFloat(value) > parseFloat(max);
        },
    };

    return normalisations;
})();



// WEBPACK FOOTER //
// ./src/helpers/forms/normalisations.js